import React, { useCallback, useEffect } from "react";
import "./tenantonboard.css";
import { OnboardingForms } from "../../../typings/onboarding";
import CustomInputs from "../../common/Inputs";
import RadioButton from "../../common/RadioButton";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import { useError } from "../../../utils/context/ErrorContext";
import DateHelper from "../../../utils/DateHelper";
import { LeaseApplicationCreditCheckVM } from "@propertelligent/client-api";
import UtilHelper from "../../../utils/UtilHelper";
import { TextCss } from "../../GlobalCss/TextCss";
import { SSN_LENGTH } from "../../../constants/onboarding";

const StepThree: React.FC<any> = ({
  formData,
  setFormData,
  CreditCheck
}: {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<OnboardingForms>>;
  CreditCheck: any
}) => {
  const { errors, setErrors, errorMessages, setErrorMessages } = useError()
  const setdata = () => {
    if (!CreditCheck) return;
    setFormData((prevFormData) => ({
      ...prevFormData,
      CreditCheck: prevFormData?.CreditCheck ? prevFormData?.CreditCheck
        : {
          taxIdNumber: "",
          dateOfBirth: "",
          consentToRunCheck: true,
        } as LeaseApplicationCreditCheckVM,
    }));
  }
  useEffect(() => { setdata() }, [CreditCheck]);

  const handleChange = useCallback((key: any, value: any,) => {
    setFormData((prevData: OnboardingForms) => ({
      ...prevData,
      CreditCheck: {
        ...prevData?.CreditCheck,
        [key]: value,
      },
    }));
    const errorKey = `${key}`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
  }, [setFormData,]);

  const Radiodata = [
    {
      id: 1,
      label: "Yes",
      value: true,
      checked: formData?.consentToRunCheck == true,
    },
    {
      id: 2,
      label: "No",
      value: false,
      checked: formData?.consentToRunCheck == false,
    },
  ]

  return (
    <>
      <div className='creditCheck' >
        <CustomInputs
          type="text"
          labelText="Social Security Number"
          placeholder="xxx-xx-xxxx"
          name="taxIdNumber"
          value={formData?.taxIdNumber}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "").slice(0, SSN_LENGTH);
            handleChange("taxIdNumber", numericValue)
          }}
          onKeyDown={(e) => UtilHelper.OnKeyDownForNumbers(e)}
          isError={errors?.taxIdNumber}
          errorMessages={errorMessages?.taxIdNumber}
          maxLength={12}
          width="100%"
        />
        <CustomInputs
          type={FORM_CONTROLFIELD_TYPES.DATE}
          labelText="Date Of Birth"
          placeholder="xxx-xxx-xxxx"
          name="dateOfBirth"
          value={DateHelper.convertUTCtoDateTime2(formData?.dateOfBirth)}
          onChange={(e) => {
            const selectedDate = new Date(e.target.value);
            const today = new Date();
            const minAgeDate = new Date();
            minAgeDate.setFullYear(today.getFullYear() - 18);

            if (selectedDate > minAgeDate) {
              setErrors((prevErrors) => ({ ...prevErrors, dateOfBirth: true }));
              setErrorMessages((prevMessages) => ({
                ...prevMessages,
                dateOfBirth: "You must be at least 18 years old.",
              }));
            } else {
              setErrors((prevErrors) => ({ ...prevErrors, dateOfBirth: false }));
              setErrorMessages((prevMessages) => ({
                ...prevMessages,
                dateOfBirth: "",
              }));
              handleChange("dateOfBirth", e.target.value);
            }
          }}
          isError={errors?.dateOfBirth}
          errorMessages={errorMessages?.dateOfBirth}
          maxLength={16}
          width="100%"
        />
      </div>
      <p className={TextCss.black.sub_heading_600_14}>
        Do you give us permission to run Credit Report on your
        behalf?
      </p>
      <div className="flexRow gap-4 py-2 ">
        {Radiodata?.map((item) => (
          <div key={item?.id}>
            <RadioButton
              id={`${item.id}`}
              label={item.label}
              value={formData?.consentToRunCheck}
              name={"consentToRunCheck"}
              checked={item.checked}
              onChange={() => handleChange("consentToRunCheck", item.value,)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default StepThree;
